import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const PreHeader = styled.div`
  border-top: 2px solid ${props => props.theme.palette.general.greyLight};
`

export const Container = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: auto;

  h1 {
    margin: 30px 0;
  }
`

export const Banner = styled.div<any>`
  display: flex;
  height: 120px;
  background-color: ${props => props.isLivbrit ? props.theme.palette.primary.gamma : props.theme.palette.primary.gammaLight};
`

export const BoxContainer = styled.div<any>`
  width: 100%;
  justify-content: space-between;
  display: flex;
  ${bp('sm')`
    flex-wrap: wrap;
  `}

  h1 {
    margin: auto ${props => props.isLivbrite ? '60px' : '10px'};
    ${bp('sm')`
      margin: auto 10px;
      font-size: 18px;
      z-index: 2
    `}
  }

  button {
    height: 40px;
    max-width: 150px;
    margin: auto 60px;
    background: ${props => props.theme.palette.general.soft};
    border-color: ${props => props.theme.palette.general.soft};
    color: ${props => props.theme.palette.general.dark};
    ${bp('sm')`
       margin: auto 10px;
    `}
  }
`

export const DivImage = styled.div`
  width: 140px;
  background-size: 201px;
  background-repeat: no-repeat;
  background-position: 116% 15%;
  ${bp('sm')`
    height: 120px;
    position: absolute;
    opacity: 0.75;
  `}
`
